export enum AppointmentStatus {
  Active = 'active',
  NotConverted = 'not_converted',
  Converted = 'converted',
  Cancelled = 'cancelled',
  Conflicted = 'conflicted',
  Terminated = 'terminated'
}
